import { Component } from '@angular/core';

import { environment } from '@env/environment';
import { Button } from '@shared/components';

@Component({
  selector: 'app-demo-cost-or-complexity',
  imports: [Button],
  templateUrl: './demo-cost-or-complexity.html',
  styleUrl: './demo-cost-or-complexity.scss',
})
export class DemoCostOrComplexity {
  readonly environment = environment;
}
